module.exports = __webpack_public_path__ + "img/meter.feda76d7.svg";